import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import auth, { actions as authActions } from './services/auth';
import stats from './services/stats';
import traits from './services/traits';
import filter from './services/filter';
import nfts from './services/nfts';

const rootReducer = combineReducers({
  auth,
  stats,
  traits,
  filter,
  nfts,
});


const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});



export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

store.dispatch(authActions.init());


export default store;